import React, { useState, useEffect } from "react";
import { Form, Input, Row, Col, Button } from "antd";
import { useDispatch } from "react-redux";
import { ticketUpdateStatusSuccess } from "../../../redux/ticketUpdateSlice/ticketUpdateSlice";
import { ticketDataSuccess } from "../../../redux/ticketSlice/ticketSlice";
import { ticketUpdateById } from "../../../http";
import { ShowAlert } from "../../../utils/showAlert";

interface PatientFormProps {
  ticketId?: string;
  defaultMobile?: string;
  defaultName?: string;
  onPatientSaved?: (patient: any) => void;
  onCancel?: () => void;
  isSaved?: boolean;
}

export const PatientForm: React.FC<PatientFormProps> = ({
  ticketId,
  defaultMobile = "",
  defaultName = "",
  onPatientSaved,
  onCancel,
  isSaved = false,
}) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    form.setFieldsValue({ fullName: defaultName });
  }, [defaultName, form]);

  const onFinish = async (values: any) => {
    setLoading(true);
    try {
      const trimmedName = values.fullName?.trim() || "";
      const patientPayload = {
        fullName: trimmedName,
        mobile: defaultMobile || "",
        whatsappNumber: defaultMobile || "",
        emergencyContacts: [],
        address: [],
        mobilityStatus: "N/A",
      };

      const ticketPayload: any = {
        patient: patientPayload,
        ticketRaisedBy: {
          fullName: trimmedName,
          mobile: defaultMobile || "",
          whatsappNumber: defaultMobile || "",
          benId: "",
        },
      };

      if (ticketId) {
        const res = await ticketUpdateById(ticketId, ticketPayload);
        dispatch(ticketDataSuccess(res?.data));
      }

      dispatch(ticketUpdateStatusSuccess({ patient: patientPayload }));
      ShowAlert("success", "Name saved successfully");
      if (onPatientSaved) {
        onPatientSaved(patientPayload);
      }
    } catch (e: any) {
      ShowAlert("warning", "Error saving name");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form
      form={form}
      name="patientForm"
      layout="vertical"
      initialValues={{
        fullName: defaultName,
      }}
      onFinish={onFinish}
    >
      <Row gutter={[16, 8]} style={{ marginTop: "0.5rem" }} align="bottom">
        <Col xs={24} sm={16} md={12}>
          <Form.Item
            name="fullName"
            label="Patient Name"
            rules={[
              { required: true, message: "Please enter name" },
              { min: 2, message: "Name must be at least 2 characters" },
            ]}
            style={{ marginBottom: 0 }}
          >
            <Input placeholder="Enter Patient Name" disabled={isSaved} size="large" />
          </Form.Item>
        </Col>

        {!isSaved && (
          <Col xs={24} sm={8} md={12}>
            <div style={{ display: "flex", gap: "8px" }}>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                size="large"
                style={{ backgroundColor: "#00A7B5", borderColor: "#00A7B5" }}
              >
                Save Name
              </Button>
              {onCancel && (
                <Button size="large" onClick={onCancel}>
                  Cancel
                </Button>
              )}
            </div>
          </Col>
        )}
      </Row>
    </Form>
  );
};
